import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('client');
    const token = localStorage.getItem('token');
    if (stored && token) {
      setClient(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const login = (clientData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('client', JSON.stringify(clientData));
    setClient(clientData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('client');
    setClient(null);
  };

  return (
    <AuthContext.Provider value={{ client, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
